"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("page", {
    staticClass: "application-page",
    attrs: {
      menu: _vm.menuItems.children,
      "sub-menu": _vm.menuItems.subMenu,
      "return-menu": "/farm-management/dashboard"
    }
  }, [_c("template", {
    slot: "context"
  }, [_c("div", {
    staticClass: "header"
  }, [_c("h2", {
    staticClass: "header-title"
  }, [_vm._v("\n        Aplicação\n      ")]), _vm._v(" "), _c("div", {
    staticClass: "search-bar"
  }, [_c("div", {
    staticClass: "field search-input"
  }, [_c("p", {
    staticClass: "filter-label"
  }, [_vm._v("\n            Filtrar por período\n          ")]), _vm._v(" "), _c("b-field", {
    attrs: {
      grouped: ""
    }
  }, [_c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data inicial",
      icon: "calendar",
      "max-date": _vm.dateEnd
    },
    on: {
      input: _vm.applyDateFilter
    },
    model: {
      value: _vm.dateStart,
      callback: function callback($$v) {
        _vm.dateStart = $$v;
      },
      expression: "dateStart"
    }
  })], 1), _vm._v(" "), _c("b-field", [_c("b-datepicker", {
    attrs: {
      placeholder: "Data final",
      icon: "calendar",
      "min-date": _vm.dateStart
    },
    on: {
      input: _vm.applyDateFilter
    },
    model: {
      value: _vm.dateEnd,
      callback: function callback($$v) {
        _vm.dateEnd = $$v;
      },
      expression: "dateEnd"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c("div", {
    staticClass: "field-new-item"
  }, [_c("b-button", {
    on: {
      click: function click($event) {
        return _vm.openApplicationModal();
      }
    }
  }, [_vm._v("\n            Nova aplicação\n          ")])], 1)])]), _vm._v(" "), _c("div", {
    staticClass: "table-items-list"
  }, [_c("b-table", {
    attrs: {
      data: _vm.applications,
      loading: _vm.isLoading,
      paginated: "",
      total: _vm.totalItems,
      "per-page": _vm.perPage,
      striped: true,
      hoverable: true,
      "backend-pagination": ""
    },
    on: {
      "page-change": _vm.onPageChange,
      click: _vm.openApplicationDetailModal
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "status",
      label: "Status"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-tag", {
          attrs: {
            type: _vm.getStatusType(props.row.status, props.row.dataAplicacao)
          }
        }, [_vm._v("\n              " + _vm._s(_vm.getStatusLabel(props.row.status, props.row.dataAplicacao)) + "\n            ")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "local",
      label: "Local"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.local) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "dataAplicacao",
      label: "Data da aplicação"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(_vm.formatDate(props.row.dataAplicacao)) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "prescricao",
      label: "Prescrição"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.prescricao) + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "produtos",
      label: "Produtos"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.produtos && props.row.produtos.length ? _c("span", [_vm._v("\n              " + _vm._s(props.row.produtos.join(", ")) + "\n            ")]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "tempoTrabalho",
      label: "Tempo de trabalho"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.tempoTrabalho || "--") + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "periodoAplicacao",
      label: "Período de aplicação"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.periodoAplicacao || "--") + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "aplicador",
      label: "Coordenador"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.aplicador || "--") + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "equipamento",
      label: "Equipamento"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n            " + _vm._s(props.row.equipamento || "--") + "\n          ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "description",
      label: "Descrição",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.description ? _c("span", {
          staticClass: "text-cell",
          attrs: {
            title: props.row.description
          }
        }, [_vm._v("\n              " + _vm._s(_vm.truncateText(props.row.description, 30)) + "\n            ")]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "observation",
      label: "Observação",
      width: "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [props.row.observation ? _c("span", {
          staticClass: "text-cell",
          attrs: {
            title: props.row.observation
          }
        }, [_vm._v("\n              " + _vm._s(_vm.truncateText(props.row.observation, 30)) + "\n            ")]) : _c("span", [_vm._v("--")])];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      width: "40"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("b-dropdown", {
          attrs: {
            "aria-role": "list",
            label: "Editar",
            position: "is-top-left"
          },
          nativeOn: {
            click: function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_c("b-button", {
          staticClass: "btn-click-dots",
          attrs: {
            slot: "trigger",
            outlined: "",
            "icon-right": "dots-vertical"
          },
          slot: "trigger"
        }), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem",
            disabled: props.row.status === "FINISHED"
          },
          on: {
            click: function click($event) {
              return _vm.openStatusModal(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "refresh",
            size: "is-small"
          }
        }), _vm._v("\n                Atualizar Status\n              ")], 1), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem",
            disabled: props.row.status === "FINISHED"
          },
          on: {
            click: function click($event) {
              return _vm.editApplication(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "pencil",
            size: "is-small"
          }
        }), _vm._v("\n                Editar\n              ")], 1), _vm._v(" "), _c("b-dropdown-item", {
          attrs: {
            "aria-role": "listitem"
          },
          on: {
            click: function click($event) {
              return _vm.deleteApplication(props.row);
            }
          }
        }, [_c("b-icon", {
          attrs: {
            icon: "delete",
            size: "is-small"
          }
        }), _vm._v("\n                Excluir\n              ")], 1)], 1)];
      }
    }])
  })], _vm._v(" "), _c("template", {
    slot: "empty"
  }, [_c("section", {
    staticClass: "section"
  }, [_c("div", {
    staticClass: "content has-text-grey has-text-centered"
  }, [_c("p", [_c("b-icon", {
    attrs: {
      icon: "emoticon-sad",
      size: "is-large"
    }
  })], 1), _vm._v(" "), _c("p", [_vm._v("Nenhuma aplicação encontrada.")])])])])], 2)], 1), _vm._v(" "), _c("ApplicationDetailsModal", {
    attrs: {
      visible: _vm.showApplicationModal,
      application: _vm.selectedApplication
    },
    on: {
      close: function close($event) {
        _vm.showApplicationModal = false;
      },
      "start-application": _vm.startApplication,
      "update-status": _vm.openStatusUpdateModal,
      "resume-application": _vm.resumeApplication
    }
  })], 1)], 2);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;